import Text from '~/components/Text';
import type { NavGroup } from '~/interfaces/publication';

import SidePanelLink from './SidePanelLink';
import SidePanelTitle from './SidePanelTitle';

interface Props {
  navGroups: NavGroup[];
}

const NavGroups = ({ navGroups }: Props) => {
  return (
    <>
      {navGroups.map((group: NavGroup) => {
        const isCategoryGroup = group.is_category_group;

        if (isCategoryGroup) {
          return null;
        }

        const navLinksLength = group?.nav_links?.length;
        if (!navLinksLength) return null;

        return (
          <div key={group.id}>
            <SidePanelTitle text={group.title} />
            <div className="mb-2 flex flex-col">
              {group?.nav_links?.map((link) => {
                const isExternalLink = link.external_link;

                if (isExternalLink) {
                  return (
                    <a key={link.id} href={link.href} target="_blank" rel="nofollow noreferrer noopener">
                      <Text as="span" type="body" theme="navs" className="text-sm opacity-75 hover:text-wt-primary">
                        {link.cta_text}
                      </Text>
                    </a>
                  );
                }

                return <SidePanelLink key={link.id} path={`/c/${link.href}`} text={link.cta_text} />;
              })}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default NavGroups;
